<script setup>
import { useToastQueue } from '@/composables/useToast'

/**
 * 轻提示的显示位置。挂在 AppShell 里，全应用只有这一个实例。
 */
const messages = useToastQueue()
</script>

<template>
  <!--
    固定在顶部而不是底部。底部在移动端被虚拟键盘、底部导航、
    以及 iOS 的home 指示条轮流占用，提示很容易被挡住或被误触。

    pointer-events-none 让提示不拦截点击：它是通知不是对话，
    用户在它显示期间应该能继续操作下面的界面。
  -->
  <div
    class="pointer-events-none fixed inset-x-0 top-0 z-[80] flex flex-col items-center
           gap-2 px-4 pt-safe-top"
    role="status"
    aria-live="polite"
  >
    <TransitionGroup
      enter-active-class="transition duration-200 ease-out"
      enter-from-class="-translate-y-2 opacity-0"
      leave-active-class="transition duration-150 ease-in"
      leave-to-class="-translate-y-2 opacity-0"
    >
      <div
        v-for="message in messages"
        :key="message.id"
        class="mt-2 max-w-sm rounded-xl px-4 py-2.5 text-sm font-medium shadow-lg"
        :class="
          message.type === 'error'
            ? 'bg-rose-600 text-white'
            : 'bg-slate-800 text-white'
        "
      >
        {{ message.text }}
      </div>
    </TransitionGroup>
  </div>
</template>
